module.exports = __webpack_public_path__ + "88c64c62b226fe62da1ca338bf2c8775.jpg";